export default __webpack_public_path__ + "static/media/google.a349e230.svg";